const userRolesBasePath = `users_roles`;
const usersRolesPaths = Object.freeze({
  list: userRolesBasePath,
  get: (userId) => `${userRolesBasePath}/${userId}`,
});

const studyBasePath = `studies`;
const studiesPaths = Object.freeze({
  list: studyBasePath,
  get: (studyId) => `${studyBasePath}/${studyId}`,
});

const studyClinicianBasePath = `studiesClinician`;
const studiesClinicianPaths = Object.freeze({
  list: studyClinicianBasePath,
  get: (studyId) => `${studyClinicianBasePath}/${studyId}`,
  getPatients: `clinicianStudySessions`,
});

const healthCollectionOptionsBasePath = `healthCollectionOptions`;
const healthCollectionOptionsPaths = Object.freeze({
  list: healthCollectionOptionsBasePath,
  get: (healthCollectionOptionId) =>
    `${healthCollectionOptionsBasePath}/${healthCollectionOptionId}`,
});

const surveyBasePath = `surveys`;
const surveysPaths = Object.freeze({
  list: surveyBasePath,
});

const exerciseBasePath = `exercises`;
const exercisesPaths = Object.freeze({
  list: exerciseBasePath,
});

const tasksBasePath = `tasks`;
const tasksPaths = Object.freeze({
  list: tasksBasePath,
});

const surveyAnswersBasePath = `taskAnswerOptions`;
const surveyAnswersPaths = Object.freeze({
  list: surveyAnswersBasePath,
});

const completedTasksBasePath = `CompletedTasks`;
const usersBasePath = `users`;
const usersPaths = Object.freeze({
  listAll: usersBasePath,
  baseCompletedTasks: completedTasksBasePath,
  completedTasks: (userId) => `${usersBasePath}/${userId}/${completedTasksBasePath}`,
});

const healthKitBasePath = (studyId, userId) =>
  `studies/${studyId}/${usersBasePath}/${userId}/healthKit`;
const healthKitPaths = Object.freeze({
  list: (studyId, userId) => healthKitBasePath(studyId, userId),
});

const metricsBasePath = (studyId, userId) =>
  `studies/${studyId}/${usersBasePath}/${userId}/metrics`;
const metricsPaths = Object.freeze({
  list: (studyId, userId) => metricsBasePath(studyId, userId),
});

export {
  usersRolesPaths,
  studiesPaths,
  surveysPaths,
  exercisesPaths,
  usersPaths,
  healthKitPaths,
  metricsPaths,
  tasksPaths,
  surveyAnswersPaths,
  studiesClinicianPaths,
  healthCollectionOptionsPaths,
};
